<template>

    <div class="col-12" :class="{ 'col-lg-6' : type === 'map' }">

        <div class="custom-response-form-description form-group">
            <label for="custom-response-form-description" class="media-label">{{ customLabel }}</label>
            <input type="text" :value="value" @input="$emit('input', $event.target.value)" class="form-control" id="custom-response-form-description" />
        </div>

    </div>

</template>


<script>


export default {

    props: {
        value : String,
        customLabel : String,
        type : String
    }
}

</script>